import {
  DEPLOYMENTS_REQUEST,
  DEPLOYMENTS_SUCCESS,
  DeploymentsRequestAction,
  DeploymentsSuccessAction,
} from 'modules/loaders';
import { DeploymentsResponse } from 'types';
import { createReducer } from 'util/reducers';

// Action types

export interface DeploymentsState {
  loading: boolean;
  heads: DeploymentsResponse;
}

// Reducer
const initialState: DeploymentsState = {
  loading: false,
  heads: {},
};

export default createReducer(initialState, {
  [DEPLOYMENTS_REQUEST](state, { payload }: DeploymentsRequestAction) {
    return {
      loading: true,
      heads: state.heads,
    };
  },
  [DEPLOYMENTS_SUCCESS](state, { payload }: DeploymentsSuccessAction) {
    return {
      loading: false,
      heads: payload,
    };
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/deployments.ts